
import api from './api';

export interface Employee {
    macc: string;
    tennv: string;
    makk: number;
    mahis?: number;
    nghiviec: boolean;
    ngayvaolam?: string;
    // Các trường chi tiết
    ngaysinh?: string;
    chungminhthu?: string;
    machuyenmon?: number;
    email?: string;
    dienthoai?: string;
    machucdanh?: number;
    machucvu?: number;
    maphai?: number;
    chungchinghe?: string;
    ngaycapcc?: string;
    ngaycapcmt?: string;
    noicapcmt?: string;
    mabhxh?: string;
}

export interface Department {
    makk: number;
    tenkk: string;
}

export interface ChucDanh {
    machucdanh: number;
    tenchucdanh: string;
    viettat: string;
}

export interface ChucVu {
    machucvu: number;
    tenchucvu: string;
    viettat?: string;
}

export interface ChuyenMon {
    machuyenmon: number;
    tenchuyenmon: string;
}

export const masterDataService = {
    getEmployees: (includeDetails: boolean = false) => api.get<Employee[]>('/masterdata/employees', { params: { includeDetails } }),
    getEmployeesByDepartment: (maKhoa: number, includeDetails: boolean = false) => api.get<Employee[]>(`/masterdata/departments/${maKhoa}/employees`, { params: { includeDetails } }),
    getDepartments: () => api.get<Department[]>('/masterdata/departments'),
    getChucDanh: () => api.get<ChucDanh[]>('/masterdata/chucdanh'),
    getChucVu: () => api.get<ChucVu[]>('/masterdata/chucvu'),
    getChuyenMon: () => api.get<ChuyenMon[]>('/masterdata/chuyenmon'),
};
